module.exports = __webpack_public_path__ + "fonts/993af67e7d11f6a6be5ee0ea511c5235.svg";